export function getRepriceValues(reprice, percent) {
  const repriceFee =
    Math.round((reprice - (reprice * 100) / (100 + percent)) * 100) / 100

  return { repriceFee, repriceGross: reprice, repriceNet: reprice - repriceFee }
}
